import paymentRepository from '@/repository/paymentRepository';
import Vue from 'vue';
import * as constants from '@/common/constants';
import {
    log
} from '@/logging';

const state = {
    paymentInfoElements: [],
    paymentInfoElementscPq: [],
    pq: false,
    infoInitTransaction: {},
    invoiceInfo: [],
    sendingInvoiceEmailInfo: [],
    errorVoucher: [],
    customerInvoice: {},
    paymentProvider: {},
    validateOffers: {},
    features: {},
    images: {},
    viewMySof: false,
    viewHbo: false,
    viewIptv: false,
    tokenMySof: null,
    viewModalImages: false,
    imagerForModalInvoice: [],
    tiempoEsperaModalInvoice: 3
}

const actions = {
    async updatePaymentInfoElements({
        commit
    }, {
        mountPayTotal,
        customerIdentificationNumber
    }) {
        let paymentInfoElements = state.paymentInfoElements;
        console.log("updatePaymentInfoElements->customerIdentificationNumber", customerIdentificationNumber);
        if (paymentInfoElements !== undefined) {
            const paymentMethods = await paymentRepository.getPaymentMethods(customerIdentificationNumber);
            commit("updatePaymentInfoElements", {
                paymentInfoElements: paymentMethods.methods,
                mountPayTotal: mountPayTotal,
                userAB:paymentMethods
            });
        }
    },
    async getValidateOffers({
        commit
    }, {
        parameters
    }) {
        let validateOffers = state.validateOffers;
        if (validateOffers !== undefined) {
            const validateOffers = await paymentRepository.validateOffers(parameters);
            commit("validateOffers", {
                validateOffers: validateOffers
            });
        }
    },
    async getFeatures({
        commit
    }, {
        parameters
    }) {
        let features = state.features;
        if (features !== undefined) {
            const features = await paymentRepository.getFeatures(parameters);
            commit("features", {
                features: features
            });
        }
    },
    async initTransaction({
        commit
    }, {
        paymentMethod,
        notificationEmail,
        customerIdentificationNumber,
        paymentType,
        paymentChannel,
        context,
        accountList,
        metadata,
        flagTypeService,
        flagTypeDue,
        paymentOption
    }) {
        let balanceStatus;

        if (paymentOption != 4) {

            if (metadata.flagCheck) {
                balanceStatus = "All";
            } else {
                if (metadata.totalOverdue) {
                    balanceStatus = "Overdue";
                } else {
                    balanceStatus = "All";
                }
            }

            /*       if (metadata.flagCheck) {
                    if (metadata.totalOverdue) {
                      balanceStatus = "All";
                    }
                    if (paymentChannel == "sucursal_virtual") {
                      balanceStatus = "All";
                    }
                  } else {
                     if (metadata.totalOverdue) {
                      if(paymentType == "normal"){
                        balanceStatus = "All";
                      }else{
                        balanceStatus = "Overdue";
                      }
                    }
                  } */

        }

        let list = accountList.map(
            (item) => {
                let arr = [];
                for (let i = 0; i < item.accounts.length; i++) {
                    let obj = {};
                    if (paymentOption != 4) {
                        obj = {
                            id: item.accounts[i].id,
                            balanceStatus: balanceStatus != undefined ? balanceStatus : (item.overdueTotalDebt > 0 ? "Overdue" : "All")
                        };

                        //for TANGO we override to ALL when account is present
                        if (metadata.payAll || (item.origen === 1 && metadata.account)) {
                            obj.balanceStatus = "All"
                        }
                    } else {
                        obj = {
                            id: item.accounts[i].id,
                            balanceStatus: ""
                        };

                        if (item.type === "HOGAR") {
                            if ((flagTypeService.HOGAR.selected && item.overdueTotalDebt > 0) && (flagTypeDue.HOGAR.selected && item.dueTotalDebt > 0)) {
                                obj.balanceStatus = "All"
                            } else if ((flagTypeService.HOGAR.selected && item.overdueTotalDebt > 0) && !flagTypeDue.HOGAR.selected) {
                                obj.balanceStatus = "Overdue"
                            } else if (!flagTypeService.HOGAR.selected && (flagTypeDue.HOGAR.selected && item.dueTotalDebt > 0)) {
                                obj.balanceStatus = "Due"
                            }
                        } else if (item.type === "MOVIL") {
                            if ((flagTypeService.MOVIL.selected && item.overdueTotalDebt > 0) && (flagTypeDue.MOVIL.selected && item.dueTotalDebt > 0)) {
                                obj.balanceStatus = "All"
                            } else if ((flagTypeService.MOVIL.selected && item.overdueTotalDebt > 0) && !flagTypeDue.MOVIL.selected) {
                                obj.balanceStatus = "Overdue"
                            } else if (!flagTypeService.MOVIL.selected && (flagTypeDue.MOVIL.selected && item.dueTotalDebt > 0)) {
                                obj.balanceStatus = "Due"
                            }
                        } else if (item.type === "PUF") {
                            if (flagTypeDue.PUF.selected && item.dueTotalDebt > 0) {
                                obj.balanceStatus = "Due"
                            }
                        }
                    }
                    if (obj.balanceStatus != "") {
                        arr.push(obj);
                    }
                }
                return arr;
            }
        ).reduce(
            (arr, item) => {
                return arr.concat(item)
            }, []
        );
        commit("createPaymentProvider", {
            paymentProvider: {
                customerIdentificationNumber: customerIdentificationNumber,
                notificationEmail: notificationEmail,
                paymentType: paymentType,
                paymentMethod: paymentMethod,
                paymentChannel: paymentChannel,
                accountList: list,
                touch: constants.touch[paymentChannel]
            }
        });
        const initTransaction = await paymentRepository.initTransaction(customerIdentificationNumber, notificationEmail, paymentType, paymentMethod, paymentChannel, list)
        commit("setInfoInitTransaction", {
            infoInitTransaction: initTransaction
        });
    },
    async retrieveErrorVoucher({
        commit,
        state
    }, {
        transaction
    }) {
        /** No me juzgues: se tuvo que hacer rápido y hubieron muchos cambios del reponse */
        let vue = new Vue();
        if (transaction !== undefined) {
            const voucher = await paymentRepository.getErrorVoucher(transaction);
            let items = [];
            let obj = voucher;
            for (const key in obj) {
                let value = obj[key];
                if (obj.hasOwnProperty(key) && value !== null) {
                    if (constants.errorInvoice[key] !== undefined) {
                        if (constants.errorInvoice[key].filter !== undefined)
                            value = vue.$options.filters[constants.errorInvoice[key].filter](value);
                        items.push({
                            desc: constants.errorInvoice[key].val,
                            val: value,
                            sort: constants.errorInvoice[key].sort
                        });
                    }
                    if ("paymentInfo" === key) {
                        for (const key in value) {
                            let data = value[key];
                            if (value.hasOwnProperty(key) && data !== null) {
                                if (constants.errorInvoice[key] !== undefined) {
                                    items.push({
                                        desc: constants.errorInvoice[key].val,
                                        val: data,
                                        sort: constants.errorInvoice[key].sort
                                    });
                                }
                            }
                        }
                    }
                }
            }

            let accounts = voucher.paymentInfo.customerBillingAccounts;
            for (const key in accounts) {
                let value = accounts[key];
                if (accounts.hasOwnProperty(key) && value !== null) {
                    if ("customer" === key) {
                        for (const attr in value) {
                            if (constants.customer[attr]) {
                                items.push({
                                    desc: constants.customer[attr].val,
                                    val: value[attr],
                                    sort: constants.customer[attr].sort
                                });
                            }
                        }
                    }
                }
            }
            let billingAccounts = accounts.billingAccounts;

            let idAccounts = [];
            for (var i = 0; billingAccounts.length >= i; i++) {
                let account = billingAccounts[i];
                for (const key in account) {
                    let value = account[key];
                    if (account.hasOwnProperty(key) && value !== null) {
                        if (constants.accounts[key] !== undefined) idAccounts.push(value);
                    }
                }
            }
            if (idAccounts.length > 0) {
                items.push({
                    desc: constants.accounts["id"].val,
                    val: idAccounts.join(","),
                    sort: constants.accounts["id"].sort
                });
            }
            commit("retrieveErrorVoucher", {
                errorVoucher: items
            })

        }
    },
    async retrieveInfoInvoice({
        commit
    }, {
        transaction
    }) {
        /** No me juzgues: se tuvo que hacer rápido y hubieron muchos cambios del reponse */
        let vue = new Vue();
        if (transaction !== undefined) {
            const invoiceData = await paymentRepository.getInvoice(transaction);
            let items = [];
            if (invoiceData == undefined) {
                items.push({
                    "desc": null
                });
                commit("retrieveInfoInvoice", {
                    invoiceInfo: items
                })
            }
            let obj = invoiceData.paymentVoucher;
            let showDueAmount = invoiceData.billingAccounts.filter(x => x.type === "PUF").length == 1 && invoiceData.billingAccounts[0].totalDebt > constants.minAmountPUFDevice;
            for (const key in obj) {
                let value = obj[key];
                if (obj.hasOwnProperty(key) && value !== null) {
                    if (constants.invoice[key] !== undefined) {
                        if (constants.invoice[key].filter !== undefined)
                            value = vue.$options.filters[constants.invoice[key].filter](
                                value
                            );
                        if ((key !== "dueAmount" || showDueAmount) && !(key == "dues" && value === 0)) {
                            items.push({
                                desc: constants.invoice[key].val,
                                val: value,
                                sort: constants.invoice[key].sort
                            });
                        }
                    }
                    if ("customer" === key) {
                        for (const attr in value) {
                            if (constants.customer[attr]) {
                                items.push({
                                    desc: constants.customer[attr].val,
                                    val: value[attr],
                                    sort: constants.customer[attr].sort
                                });
                            }
                        }
                    }
                }
            }
            let info = invoiceData.paymentInfo;
            for (const key in info) {
                let value = info[key];
                if (info.hasOwnProperty(key) && value !== null) {
                    if (constants.info[key] !== undefined) {
                        items.push({
                            desc: constants.info[key].val,
                            val: value,
                            sort: constants.info[key].sort
                        });
                    }
                }
            }
            let accounts = invoiceData.billingAccounts;
            let idAccounts = [];
            for (var i = 0; accounts.length >= i; i++) {
                let account = accounts[i];
                for (const key in account) {
                    let value = account[key];
                    if (account.hasOwnProperty(key) && value !== null) {
                        if (accounts[i].type != null && accounts[i].type != undefined && accounts[i].type != '') {
                            //N° de cuenta   HOGAR: 2749010, MOVIL: 2749010
                            if (constants.accounts[key] !== undefined) idAccounts.push(accounts[i].type + ": " + value);
                        } else {
                            if (accounts.length == 1) {
                                //Cuando no viene tipo de cuenta y solo es una cuenta -> N° de cuenta  2749010
                                if (constants.accounts[key] !== undefined) idAccounts.push(value);
                            } else {
                                //Cuando no viene tipo de cuenta y es mas de una cuenta -> N° de cuenta   HOGAR: 2749010, Cuenta: 2749010
                                if (constants.accounts[key] !== undefined) idAccounts.push("Cuenta: " + value);
                            }
                        }
                    }
                }
            }
            if (idAccounts.length > 0) {
                items.push({
                    desc: constants.accounts["id"].val,
                    val: idAccounts.join(", "),
                    sort: constants.accounts["id"].sort
                });
            }
            commit("retrieveInfoInvoice", {
                invoiceInfo: items
            })
            commit("customerInvoice", {
                customerInvoice: invoiceData.paymentVoucher.customer
            })
        }
    },

    async sendingInvoiceEmail({
        commit
    }, {
        transaction,
        email
    }) {
        if (transaction !== undefined && email !== undefined) {
            const sendInvoiceEmailData = await paymentRepository.sendInvoiceEmail(transaction, email);
            if (sendInvoiceEmailData !== undefined) {
                commit("sendingInvoiceEmail", {
                    sendingInvoiceEmailInfo: sendInvoiceEmailData
                })
            } else {
                commit("sendingInvoiceEmail", {
                    sendingInvoiceEmailInfo: null
                })
            }
        }
    },
    resetPaymentState({
        commit
    }) {
        commit('resetPaymentState')
    },
    resetSendingInvoiceEmailState({
        commit
    }) {
        commit('resetSendingInvoiceEmailState')
    }
}

const getters = {
userAB(state){
    return state.userAB
},


    paymentInfoElements(state) {
        return state.paymentInfoElements;
    },
    paymentInfoElementscPq(state) {
        return state.paymentInfoElementscPq;
    },
    pq(state) {
        return state.pq;
    },
    validateOffers(state) {
        return state.validateOffers;
    },
    features(state) {
        return state.features;
    },
    viewModalImages(state) {
        return state.viewModalImages;
    },
    imagerForModalInvoice(state) {
        return state.imagerForModalInvoice;
    },
    tiempoEsperaModalInvoice(state) {
        return state.tiempoEsperaModalInvoice;
    },
    infoInitTransaction(state) {
        return state.infoInitTransaction;
    },
    invoice(state) {
        return state.invoiceInfo;
    },
    sendingInvoice(state) {
        return state.sendingInvoiceEmailInfo;
    },
    errorVoucher(state) {
        return state.errorVoucher;
    },
    customer(state) {
        return state.customerInvoice;
    },
    viewMySof(state) {
        return state.viewMySof;
    },
    viewHbo(state) {
        return state.viewHbo;
    },
    viewIptv(state) {
        return state.viewIptv;
    },
    tokenMySof(state) {
        return state.tokenMySof;
    },
    images(state) {
        return state.images;
    },
    paymentProvider(state) {
        return state.paymentProvider;
    }
}

const mutations = {
    updatePaymentInfoElements(state, {
        paymentInfoElements,
        mountPayTotal,
        userAB
    }) {
        state.paymentInfoElements = [];
        state.paymentInfoElementscPq = [];
        state.pq = false;
        let listSnPQ = [];
        let num = 10
        for (let met of paymentInfoElements) {
            met.pasaPQ = false;
            if (met.pqActivo) {
                if (mountPayTotal > met.pq) {
                    met.order = num
                    met.pasaPQ = true;
                    state.pq = true
                } else {
                    listSnPQ.push(met)
                }
            } else {
                listSnPQ.push(met)
            }
            num++;
        }
        if (state.pq) {
            listSnPQ.push({ "order": 99, "name": "omp", "enable": true })
        }
        console.log("paymentInfoElementscPq", paymentInfoElements)
        console.log("paymentInfoElements", listSnPQ)
        state.paymentInfoElementscPq = paymentInfoElements;
        state.paymentInfoElements = listSnPQ;
        state.userAB = userAB;
    },
    validateOffers(state, {
        validateOffers
    }) {
        console.log("validateOffers MUT", validateOffers);
        state.validateOffers = {};
        state.validateOffers = validateOffers;
        if (validateOffers.acceso) {
            state.viewMySof = true;
            state.tokenMySof = validateOffers.token;
        } else {
            state.viewMySof = false;
            state.tokenMySof = null;
        }
        if (validateOffers.accesoHbo)
            state.viewHbo = true;
        else
            state.viewHbo = false;
    },
    features(state, {
        features
    }) {
        console.log("features MUT", features);

        state.images = features.imagenes;
        console.log("features IMAGES", state.images);
        state.features = {};
        state.features = features;
        if (features.acceso) {
            state.viewMySof = true;
            state.tokenMySof = features.token;
        } else {
            state.viewMySof = false;
            state.tokenMySof = null;
        }
        if (features.accesoHbo) {
            state.viewHbo = true;
        } else {
            state.viewHbo = false;
        }

        if (features.accesoIptv) {
            state.viewIptv = true;
        } else {
            state.viewIptv = false;
        }
        state.imagerForModalInvoice = [];
        state.imagerForModalInvoice = features.modalImages;
        state.tiempoEsperaModalInvoice = features.cierreModalEspera;
        if (state.imagerForModalInvoice.length > 0) {
            state.viewModalImages = true;

        } else {
            state.viewModalImages = false;
        }
        console.log("features.modalImages MUT", state.viewModalImages);
        console.log("features.modalImages MUT", features.modalImages);


    },
    tokenMySof(state, {
        tokenMySof
    }) {
        console.log("tokenMySof MUT", tokenMySof);
        state.tokenMySof = {};
        state.tokenMySof = tokenMySof;
    },
    setInfoInitTransaction(state, {
        infoInitTransaction
    }) {
        state.infoInitTransaction = {};
        state.infoInitTransaction = infoInitTransaction;
    },
    retrieveInfoInvoice(state, {
        invoiceInfo
    }) {
        state.invoiceInfo = [];
        state.invoiceInfo = invoiceInfo;
    },
    sendingInvoiceEmail(state, {
        sendingInvoiceEmailInfo
    }) {
        state.sendingInvoiceEmailInfo = [];
        state.sendingInvoiceEmailInfo = sendingInvoiceEmailInfo;
    },
    retrieveErrorVoucher(state, {
        errorVoucher
    }) {
        state.errorVoucher = [];
        state.errorVoucher = errorVoucher;
    },
    customerInvoice(state, {
        customerInvoice
    }) {
        state.customerInvoice = {}
        state.customerInvoice = customerInvoice;
    },
    createPaymentProvider(state, {
        paymentProvider
    }) {
        state.paymentProvider = {}
        state.paymentProvider = paymentProvider;
    },
    viewMySof(state, viewMySof) {
        if (viewMySof) {
            state.viewMySof = true;
        } else {
            state.viewMySof = false;
        }
    },
    viewHbo(state, viewHbo) {
        if (viewHbo) {
            state.viewHbo = true;
        } else {
            state.viewHbo = false;
        }
    },
    viewIptv(state, viewIptv) {
        if (viewIptv) {
            state.viewIptv = true;
        } else {
            state.viewIptv = false;
        }
    },
    viewModalImages(state, viewModalImages) {
        if (viewModalImages) {
            state.viewModalImages = true;
        } else {
            state.viewModalImages = false;
        }
    },
    resetPaymentState(currentState) {
        const s = state;
        Object.keys(s).forEach(key => {
            currentState[key] = s[key]
        })
    },
    resetSendingInvoiceEmailState(currentState) {
        const s = state;
        Object.keys(s).forEach(key => {
            currentState[key] = undefined
        })
    }
}

export {
    state,
    actions,
    getters,
    mutations,
}